import injectSheet from 'react-jss'
import LoadingIcon from './LoadingIcon'
import styles from './LoadingIcon.styles'

export default injectSheet(styles)(LoadingIcon)
